import { useSiteI18n } from './i18n/siteI18n';

function Rooter() {
  const { t } = useSiteI18n();

  return (
    <footer className="App-footer">
      <div className="App-footer-links">
        <a href="/app_privacy_policy.html" className="App-link" rel="noreferrer">
          {t('privacyPolicy')}
        </a>
        <span className="App-footer-divider">|</span>
        <a href="/tos.html" className="App-link" rel="noreferrer">
          {t('termsOfService')}
        </a>
        <span className="App-footer-divider">|</span>
        <a href="/support" className="App-link" rel="noreferrer">
          {t('support')}
        </a>
      </div>
      <p className="App-footer-copy">{t('copyright')}</p>
    </footer>
  );
}

export default Rooter;
